export default "__VITE_ASSET__73d12671__"